export enum PointerState {
  NONE = 0,
  HOVER = 1,
  SELECT = 2,
}
